import BigNumber from "bignumber.js";
export function toBtc(value: string | number, num: string | number) {
  return new BigNumber(value).times(num).toString()
}
